<template>
    <Vendors></Vendors>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Vendors = defineAsyncComponent(() =>
    import("../../components/Purchasing/Vendors/Table.vue")
);

export default {
    name: "Vendors_Purchashing",
    components: { Vendors, AuthLayout },
};
</script>
